import { z } from "zod";
import { PathParamsIdString } from "../_core.js";
import { SalesCreditMemo, SalesCreditMemoLine, SalesInvoice, SalesInvoiceCustom, SalesInvoiceLine, } from "../business_central.js";
export const ListInvoicesSearchParams = z
    .object({
    invoiceDateFrom: z.string().optional(),
})
    .meta({ ref: "ListInvoicesSearchParams" });
export const ListInvoicesResponseBody = z
    .object({
    salesCreditMemos: SalesCreditMemo.array(),
    salesInvoices: SalesInvoice.array(),
})
    .meta({ ref: "ListInvoicesResponseBody" });
export const ReadSalesInvoicePathParams = PathParamsIdString.meta({
    ref: "ReadSalesInvoicePathParams",
});
export const ReadSalesInvoiceSearchParams = z
    .object({
    includePdf: z.coerce.boolean().optional(),
})
    .meta({ ref: "ReadSalesInvoiceSearchParams" });
export const ReadSalesInvoiceResponseBody = z
    .object({
    salesInvoice: SalesInvoice.pick({
        id: true,
        number: true,
        customerId: true,
        customerNumber: true,
        invoiceDate: true,
        dueDate: true,
        status: true,
        currencyCode: true,
        totalAmountIncludingTax: true,
        totalAmountExcludingTax: true,
        totalTaxAmount: true,
    }).merge(SalesInvoiceCustom.pick({
        companyBankAccountNo: true,
        KID: true,
        consumption: true,
        CO2TAX: true,
    })),
    salesInvoiceLines: z.array(SalesInvoiceLine),
    salesInvoicePdf: z.string().nullable(),
})
    .meta({ ref: "ReadSalesInvoiceResponseBody" });
export const ReadSalesCreditMemoPathParams = PathParamsIdString.meta({
    ref: "ReadSalesCreditMemoPathParams",
});
export const ReadSalesCreditMemoSearchParams = z
    .object({
    includePdf: z.coerce.boolean().optional(),
})
    .meta({ ref: "ReadSalesCreditMemoSearchParams" });
export const ReadSalesCreditMemoResponseBody = z
    .object({
    salesCreditMemo: SalesCreditMemo.pick({
        id: true,
        number: true,
        customerId: true,
        customerNumber: true,
        creditMemoDate: true,
        dueDate: true,
        status: true,
        currencyCode: true,
        totalAmountIncludingTax: true,
        totalAmountExcludingTax: true,
        totalTaxAmount: true,
    }).merge(z.object({
        CO2TAX: z.number().nonnegative(),
        KID: z.literal(null),
        companyBankAccountNo: z.literal(null),
        consumption: z.number().nonnegative(),
    })),
    salesCreditMemoLines: z.array(SalesCreditMemoLine),
    salesCreditMemoPdf: z.string().nullable(),
})
    .meta({ ref: "ReadSalesCreditMemoResponseBody" });
